import { render, staticRenderFns } from "./Layout_GLYF_user_center.vue?vue&type=template&id=670f5b42&scoped=true"
import script from "./Layout_GLYF_user_center.vue?vue&type=script&lang=js"
export * from "./Layout_GLYF_user_center.vue?vue&type=script&lang=js"
import style0 from "./Layout_GLYF_user_center.vue?vue&type=style&index=0&id=670f5b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f5b42",
  null
  
)

export default component.exports